// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MediaItem__container-ccbd95 {
  border-radius: 2px;
  overflow: hidden;
  background-color: var(--base-30);
  position: relative;
  width: 100% !important;
  height: 100% !important;
}

.MediaItem__container-ccbd95:hover {
  cursor: pointer;
}

.MediaItem__container-ccbd95 img {
  object-fit: cover;
}

.MediaItem__upload-state-e2914a {
  width: 40px;
  height: 40px;
}

.MediaItem__video-icon-f95813 {
  width: 24px;
  height: 24px;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  inset-inline-start: 4px;
  bottom: 4px;
  border-radius: 50%;
  background-color: var(--addition-40_60);
  color: var(--addition-50);
}

.MediaItem__video-icon-f95813 svg {
  fill: currentColor;
}`, "",{"version":3,"sources":["webpack://./src/main/SharedData/Media/MediaItem/MediaItem.styles.m.css"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,gBAAA;EACA,gCAAA;EACA,kBAAA;EACA,sBAAA;EACA,uBAAA;AACF;;AAEA;EACE,eAAA;AACF;;AAEA;EACE,iBAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,uBAAA;EACA,WAAA;EACA,kBAAA;EACA,uCAAA;EACA,yBAAA;AACF;;AAEA;EACE,kBAAA;AACF","sourcesContent":[".container {\n  border-radius: 2px;\n  overflow: hidden;\n  background-color: var(--base-30);\n  position: relative;\n  width: 100% !important;\n  height: 100% !important;\n}\n\n.container:hover {\n  cursor: pointer;\n}\n\n.container img {\n  object-fit: cover;\n}\n\n.upload-state {\n  width: 40px;\n  height: 40px;\n}\n\n.video-icon {\n  width: 24px;\n  height: 24px;\n  position: absolute;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  inset-inline-start: 4px;\n  bottom: 4px;\n  border-radius: 50%;\n  background-color: var(--addition-40_60);\n  color: var(--addition-50);\n}\n\n.video-icon svg {\n  fill: currentColor;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `MediaItem__container-ccbd95`,
	"upload-state": `MediaItem__upload-state-e2914a`,
	"uploadState": `MediaItem__upload-state-e2914a`,
	"video-icon": `MediaItem__video-icon-f95813`,
	"videoIcon": `MediaItem__video-icon-f95813`
};
module.exports = ___CSS_LOADER_EXPORT___;
